module.exports = {
    configuration_hubspot_title: "Configuración Punto de Acceso",
    configuration_hubspot_enable: "Encendido",
    configuration_hubspot_disable: "Apagado",
    configuration_hubspot: "Punto de Acceso",
    configuration_hubspot_message: "* Éste parametro permite encender/apagar la función NAT en la cámara",
    configuration_hubspot_cycle_begin_day: "Día de inicio del ciclo",
    configuration_hubspot_cycle_begin_day_message: "* En este día el consumo mensual se reinicia",
    configuration_hubspot_max_monthly_usage: "Máximo uso mensual en MB",
    configuration_hubspot_max_monthly_usage_message: "* Máximo consumo de datos en MB, permitido en el mes",
    configuration_hubspot_day: "dia(s)",
    configuration_hubspot_mb: "MB",


    configuration_hubspot_all_events: "Todos los Eventos",
    configuration_hubspot_group_events: "Grupos de Eventos",
    configuration_hubspot_specific_events: "Eventos Específicos",
    configuration_hubspot_all_accel_events: "Todos los ecentos de Aceleración",
    configuration_hubspot_all_dms_events: "Todos los Eventos DMS",
    configuration_hubspot_all_adas_events: "Todos los Eventos ADAS",
    configuration_hubspot_events: "Eventos",
    configuration_hubspot_accel_events: "Eventos de Aceleración",
    configuration_hubspot_dms_events: "Eventos DMS",
    configuration_hubspot_adas_events: "Eventos ADAS",
    configuration_hubspot_others_events: "Otros Eventos",
    configuration_hubspot_clip: "Clip",
    configuration_hubspot_picture: "Imagen",

    configuration_hubspot_severe_brake: "Freno Severo",
    configuration_hubspot_hard_brake: "Freno Duro",
    configuration_hubspot_harsh_brake: "Freno Brusco",
    configuration_hubspot_harsh_accel: "Aceleracion Brusca",
    configuration_hubspot_harsh_turn: "Giro Brusco",
    configuration_hubspot_sharp_turn: "Giro Cerrado",
    configuration_hubspot_severe_turn: "Giro Severo",
    configuration_hubspot_driving_hit: "Choque",
    configuration_hubspot_severe_accel: "Aceleración Severa",
    configuration_hubspot_driving_heavy_hit: "Choque Fuerte",
    configuration_hubspot_hard_accel: "Aceleración Dura",

    configuration_hubspot_using_phone: "Usando el Teléfono",
    configuration_hubspot_smoking: "Fumando",
    configuration_hubspot_drowsiness: "Somnolencia",
    configuration_hubspot_no_seatbelt: "Sin Cinturón de Seguridad",
    configuration_hubspot_no_driver: "Sin Conductor",
    configuration_hubspot_daydreaming: "Soñador",
    configuration_hubspot_yawn: "Bostezo",
    configuration_hubspot_asleep: "Dormido",
    configuration_hubspot_distracted: "Distraído",

    configuration_hubspot_forward_collision_warning: "Advertencia de Colisión Frontal",
    configuration_hubspot_headway_monitoring_warning: "Advertencia de Monitoreo de Avance",
    configuration_hubspot_headway_monitoring_emergency: "Emergencia de Monitoreo de Avance",
    configuration_hubspot_lane_departure_warning: "Advertencia de Cambio de Carril",

    configuration_hubspot_manual: "Manual",

    configuration_hubspot_save_title: "Guardado de configuración de modo de carga",
    configuration_hubspot_save_success: "Configuración de modo de carga guadado",
    configuration_hubspot_save_error: "Error en el guardado de la configuración modo de carga",

    configuration_hubspot_next: "Siguiente",
    configuration_hubspot_back: "Atrás",
    configuration_hubspot_apply: "Aplicar",
    configuration_hubspot_potential_incident_low: "Incidente Potencial Bajo",
    configuration_hubspot_potential_incident_medium: "Incidente Potencial Medio",
    configuration_hubspot_potential_incident_high: "Incidente Potencial Alto",
    configuration_hubspot_driving_suspicious_hit: "Choque Sospechoso",
    configuration_hubspot_idle_no_driver: "Activo sin Conductor",
    configuration_hubspot_power_lost: "Perdida de Poder",
    configuration_hubspot_500mb: "500 MB",
    configuration_hubspot_1gb: "1 GB"
}